import { Messenger, UserRole, type User } from '@promtver/contracts';

import { apiRequest } from './client';

/** «Сырая» запись пользователя из /auth/me — маппим в контракт User явно. */
interface RawProfileUser {
  id?: string;
  messenger?: string;
  messengerId?: string;
  displayName?: string | null;
  phone?: string | null;
  email?: string | null;
  role?: string;
  enterpriseId?: string | null;
  consentAt?: string | null;
  consentVersion?: string | null;
  deletedAt?: string | null;
  createdAt?: string | null;
}

interface RawProfileResponse {
  user?: RawProfileUser;
}

function toUserRole(value: string | undefined): UserRole {
  return Object.values(UserRole).find((role) => role === value) ?? UserRole.Guest;
}

/**
 * Профиль текущего пользователя по действующему токену.
 *
 * Ответ /auth/login содержит только токены, поэтому роль добираем отсюда:
 * без неё панель не может отличить «нет прав» от «вход ещё не подтверждён».
 */
export async function fetchCurrentUser(): Promise<User | null> {
  const body = await apiRequest<RawProfileResponse>('/auth/me');
  const raw = body.user;
  if (!raw?.id) return null;

  return {
    id: raw.id,
    messenger: raw.messenger === Messenger.Max ? Messenger.Max : Messenger.Telegram,
    messengerId: raw.messengerId ?? '',
    displayName: raw.displayName ?? null,
    phone: raw.phone ?? null,
    email: raw.email ?? null,
    role: toUserRole(raw.role),
    consentAt: raw.consentAt ?? null,
    consentVersion: raw.consentVersion ?? null,
    enterpriseId: raw.enterpriseId ?? null,
    pointsBalance: 0,
    deletedAt: raw.deletedAt ?? null,
    createdAt: raw.createdAt ?? '',
  };
}
